import { HTTP } from './helpers/http.js'
import qs from 'qs'

export default {
  create(organizationId, payload) {
    const url = `/api/v1/organizations/${organizationId}/tasks`
    return HTTP.post(url, payload)
  },

  update(organizationId, taskId, payload) {
    const url = `/api/v1/organizations/${organizationId}/tasks/${taskId}`
    return HTTP.patch(url, payload)
  },

  getById(organizationId, taskId) {
    const url = `/api/v1/organizations/${organizationId}/tasks/${taskId}`
    return HTTP.get(url)
  },

  getAll(args = {}) {
    const {
      organizationId,
      filters = {},
      sort = {},
      limit,
      from,
      page,
      terms,
      projections = [],
      expansions = [],
    } = args
    const params = {
      filters,
      sort,
      from,
      limit,
      page,
      terms,
      projections,
      expansions,
    }

    return HTTP.get(`/api/v1.1/stream/${organizationId}/tasks`, {
      params,
      paramsSerializer(parameters) {
        return qs.stringify(parameters, { arrayFormat: 'brackets' })
      },
    })
  },

  delete(organizationId, taskId) {
    const url = `/api/v1/organizations/${organizationId}/tasks/${taskId}`
    return HTTP.delete(url)
  },

  attach(organizationId, taskId, payload) {
    const url = `/api/v1/organizations/${organizationId}/tasks/${taskId}/attachments`
    return HTTP.post(url, payload)
  },

  getAttachments(organizationId, taskId) {
    const url = `/api/v1/organizations/${organizationId}/tasks/${taskId}/attachments`
    return HTTP.get(url)
  },
}
